import moment from 'moment';

import {
    USERS_ENTITY,
    SUBCATEGORIES_ENTITY,
    CATEGORIES_ENTITY,
    DEFECT_TYPES_ENTITY,
    ORDER_LIST_ENTITY,
    COMPLAINTS_ENTITY,
    MANAGER_TECHNICIAN_ENTITY,
    ASSETS_ENTITY,
    LOCATIONS_ENTITY,
    CONTACT_INFO,
    APPLICATION_FORM_QUESTIONS,
    APPLICATION_FORM_PACKAGE_PLANS,
    APPLICATION_FORM_SERVICES,
    APPLICATION_FORM_PACKAGES,
    SERVICE_PROCESS_STEPS,
    SERVICE_PROCESS_DETAILS,
    SERVICE_PROCESS_SUBTITLE,
    MODELS_ENTITY,
    CATEGORY_SUBCATEGORIES_ENTITY,
    COUPONS_ENTITY,
    GARAGE_COMMISSION_TYPE,
    USERS_LIST_ENTITY,
    FEATURED_COLLECTION,
    CURATED_SPACES,
    CUSTOMIZABLE_PRODUCTS,
    MOODBOARD_SECTIONS,
    COLLABORATION_SECTIONS,
    CATEGORY,
    COLLABS,
    PRODUCTS,
    STORIES,
    PRODUCT_CATEGORIES,
    CATALOGUE,
    ABOUT,
    SPACES,
    CONTACT,
    HEADER_INFO,
} from '../constants/EntityName';

export const positionSort = (firstEntity: { position: number }, secondEntity: { position: number }) =>
    firstEntity.position - secondEntity.position;

export const getIncomingPayload = (entityName: string, apiData: any) => {
    switch (entityName) {
        case FEATURED_COLLECTION: {
            return {
                ...apiData,
                desktopPngUrl: apiData?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.images[0]?.mobileWebPUrl,
                imageInfo: apiData?.images[0]?.imageInfo,
            };
        }

        case CURATED_SPACES: {
            return {
                ...apiData,
                desktopPngUrl: apiData?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.images[0]?.mobileWebPUrl,
                imageInfo: apiData?.images[0]?.imageInfo,
            };
        }

        case CUSTOMIZABLE_PRODUCTS: {
            return {
                ...apiData,
                desktopPngUrl: apiData?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.images[0]?.mobileWebPUrl,
                imageInfo: apiData?.images[0]?.imageInfo,
            };
        }

        case MOODBOARD_SECTIONS: {
            return {
                ...apiData,
                desktopPngUrl: apiData?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.images[0]?.mobileWebPUrl,
                imageInfo: apiData?.images[0]?.imageInfo,
            };
        }

        case COLLABORATION_SECTIONS: {
            return {
                ...apiData,
                desktopPngUrl: apiData?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.images[0]?.mobileWebPUrl,
                imageInfo: apiData?.images[0]?.imageInfo,
            };
        }

        case CATEGORY: {
            const { isSpatialRender, spatialRenderImages, name, status, type } = apiData;

            const res = {
                name,
                status,
                type,
                // New images field for multiImageUpload - format it to match what setFileValue() expects
                images: apiData?.headerImage
                    ? apiData.headerImage.map((img: any) => ({
                          desktopPngUrl: img?.desktopPngUrl || '',
                          desktopWebPUrl: img?.desktopWebPUrl || '',
                          mobilePngUrl: img?.mobilePngUrl || '',
                          mobileWebPUrl: img?.mobileWebPUrl || '',
                          imageInfo: img?.imageInfo || '',
                      }))
                    : [],
                // Keep desktopPngUrl for backward compatibility and table display
                desktopPngUrl: apiData?.headerImage?.[0]?.desktopPngUrl
                    ? [{ url: apiData.headerImage[0].desktopPngUrl, uid: 'desktop-png' }]
                    : [],
                isSpatialRenderProductDropdown: isSpatialRender,
            };

            if (isSpatialRender) {
                Object.assign(res, {
                    desktopSpatialPngUrl1: spatialRenderImages[0]?.urls?.[0].desktopPngUrl,
                    desktopSpatialWebPUrl1: spatialRenderImages[0]?.urls?.[0].desktopWebPUrl,
                    mobileSpatialPngUrl1: spatialRenderImages[0]?.urls?.[0].mobilePngUrl,
                    mobileSpatialWebPUrl1: spatialRenderImages[0]?.urls?.[0].mobileWebPUrl,
                    desktopSpatialPngUrl2: spatialRenderImages[1]?.urls?.[0].desktopPngUrl,
                    desktopSpatialWebPUrl2: spatialRenderImages[1]?.urls?.[0].desktopWebPUrl,
                    mobileSpatialPngUrl2: spatialRenderImages[1]?.urls?.[0].mobilePngUrl,
                    mobileSpatialWebPUrl2: spatialRenderImages[1]?.urls?.[0].mobileWebPUrl,
                });
            }

            return res;
        }

        case COLLABS: {
            return {
                ...apiData,
                desktopPngUrl: apiData?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.images[0]?.mobileWebPUrl,
                imageInfo: apiData?.images[0]?.imageInfo,
                title: apiData?.content[0]?.title,
                description: apiData?.content[0]?.description,
                remarkAuthor: apiData?.remark?.author,
                remarkDesignation: apiData?.remark?.designation,
                remarkText: apiData?.remark?.text,

                heroDesktopPngUrl: apiData?.heroImage?.desktopPngUrl,
                heroDesktopWebPUrl: apiData?.heroImage?.desktopWebPUrl,
                heroMobilePngUrl: apiData?.heroImage?.mobilePngUrl,
                heroMobileWebPUrl: apiData?.heroImage?.mobileWebPUrl,
                heroImageInfo: apiData?.heroImage?.imageInfo,
                featuredProducts: apiData?.featuredProducts.map((item: { _id: string; name: string }) => ({
                    value: item._id,
                    name: item.name,
                })),
            };
        }

        case PRODUCTS: {
            const res = {
                ...apiData,
                desktopPngUrl: apiData?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.images[0]?.mobileWebPUrl,
                specialImages: apiData?.spatialRenderImages,
                downloads: apiData?.downloads[0],
            };

            return res;
        }

        case SPACES: {
            return {
                ...apiData,
                desktopPngUrl: apiData?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.images[0]?.mobileWebPUrl,
                imageInfo: apiData?.images[0]?.imageInfo,
                products: apiData?.products.map((item: { _id: string; name: string }) => ({
                    value: item._id,
                    name: item.name,
                })),
            };
        }

        case STORIES: {
            return {
                ...apiData,
                desktopPngUrl: apiData?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.images[0]?.mobileWebPUrl,
                imageInfo: apiData?.images[0]?.imageInfo,
                title: apiData?.content[0]?.title,
                description: apiData?.content[0]?.description,
                publishDate: moment(apiData?.publishDate),
                heroDesktopPngUrl: apiData?.heroImage?.desktopPngUrl,
                heroDesktopWebPUrl: apiData?.heroImage?.desktopWebPUrl,
                heroMobilePngUrl: apiData?.heroImage?.mobilePngUrl,
                heroMobileWebPUrl: apiData?.heroImage?.mobileWebPUrl,
                heroImageInfo: apiData?.heroImage?.imageInfo,
                designation: apiData?.content[0]?.authorDetails?.designation,
                name: apiData?.content[0]?.authorDetails?.name,
                featuredProducts: apiData?.featuredProducts.map((item: { _id: string; name: string }) => ({
                    value: item._id,
                    name: item.name,
                })),
            };
        }

        case PRODUCT_CATEGORIES: {
            return {
                ...apiData.results,
                desktopPngUrl: apiData?.results[0]?.category?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.results[0]?.category?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.results[0]?.category?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.results[0]?.category?.images[0]?.mobileWebPUrl,
                categoryName: apiData?.results[0]?.category?.categoryName,
            };
        }

        case CATALOGUE: {
            return {
                ...apiData,
                desktopPngUrl: apiData?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.images[0]?.mobileWebPUrl,
                imageInfo: apiData?.images[0]?.imageInfo,
            };
        }

        case ABOUT: {
            return {
                ...apiData,
                desktopPngUrl: apiData?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.images[0]?.mobileWebPUrl,
            };
        }

        case CONTACT: {
            return {
                ...apiData,
                email: apiData?.customerCare?.email,
                mobile: apiData?.customerCare?.mobile,
                enEmail: apiData?.enquries?.email,
                enMobile: apiData?.enquries?.mobile,
                shEmail: apiData?.showroomDetails[0]?.email,
                shMobile: apiData?.showroomDetails[0]?.mobile,
                address: apiData?.showroomDetails[0]?.address,
                location: apiData?.showroomDetails[0]?.location,
                timing: apiData?.showroomDetails[0]?.timing,
                desktopPngUrl: apiData?.showroomDetails[0]?.images[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.showroomDetails[0]?.images[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.showroomDetails[0]?.images[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.showroomDetails[0]?.images[0]?.mobileWebPUrl,
                imageInfo: apiData?.showroomDetails[0]?.images[0]?.imageInfo,
            };
        }

        case HEADER_INFO: {
            return {
                ...apiData,
                desktopPngUrl: apiData?.heroImage[0]?.desktopPngUrl,
                desktopWebPUrl: apiData?.heroImage[0]?.desktopWebPUrl,
                mobilePngUrl: apiData?.heroImage[0]?.mobilePngUrl,
                mobileWebPUrl: apiData?.heroImage[0]?.mobileWebPUrl,
                imageInfo: apiData?.heroImage[0]?.imageInfo,
                // Second set of images for careersHeader
                desktopPngUrl2: apiData?.heroImage[1]?.desktopPngUrl,
                desktopWebPUrl2: apiData?.heroImage[1]?.desktopWebPUrl,
                mobilePngUrl2: apiData?.heroImage[1]?.mobilePngUrl,
                mobileWebPUrl2: apiData?.heroImage[1]?.mobileWebPUrl,
            };
        }

        case USERS_ENTITY: {
            return Object.entries(apiData).reduce((acc, [key, value]: any) => {
                // if (key === 'role') {
                //     return { ...acc, [key]: value.id };
                // }

                if (key === 'password') {
                    return { ...acc, [key]: '*****' };
                }

                return { ...acc, [key]: value };
            }, {});
        }

        case MODELS_ENTITY: {
            return {
                ...apiData,
                make: apiData?.make?.id,
            };
        }

        case CATEGORY_SUBCATEGORIES_ENTITY: {
            return {
                ...apiData,
                category: apiData?.category?.id,
            };
        }

        case APPLICATION_FORM_QUESTIONS: {
            return Object.entries(apiData).reduce((acc, [key, value]: any) => {
                if (key === 'service') {
                    return { ...acc, [key]: value?.id };
                }

                return { ...acc, [key]: value };
            }, {});
        }

        case DEFECT_TYPES_ENTITY: {
            return Object.entries(apiData).reduce((acc, [key, value]: any) => {
                if (key === 'subcategory') {
                    return { ...acc, [key]: value.id };
                }

                return { ...acc, [key]: value };
            }, {});
        }

        case LOCATIONS_ENTITY:
        case ASSETS_ENTITY: {
            return Object.entries(apiData).reduce((acc, [key, value]: any) => {
                if (key === 'locationType') {
                    return { ...acc, [key]: value.id };
                }

                return { ...acc, [key]: value };
            }, {});
        }

        case CATEGORIES_ENTITY: {
            return Object.entries(apiData).reduce((acc, [key, value]: any) => {
                if (key === 'asset') {
                    return { ...acc, [key]: value?.id };
                }
                if (key === 'manager') {
                    return { ...acc, [key]: value?.id };
                }

                return { ...acc, [key]: value };
            }, {});
        }

        case SUBCATEGORIES_ENTITY: {
            return Object.entries(apiData).reduce((acc, [key, value]: any) => {
                if (key === 'category') {
                    return { ...acc, [key]: value?.id };
                }

                return { ...acc, [key]: value };
            }, {});
        }

        case COMPLAINTS_ENTITY: {
            return Object.entries(apiData).reduce((acc, [key, value]: any) => {
                if (key === 'defectType') {
                    return { ...acc, [key]: value?.id };
                }

                return { ...acc, [key]: value };
            }, {});
        }

        case APPLICATION_FORM_SERVICES: {
            return {
                ...apiData,
                parameters: apiData?.parameters?.map((parameter: { id: string }) => parameter.id),
            };
        }

        case APPLICATION_FORM_PACKAGES: {
            return {
                ...apiData,
                service: apiData?.service?.id,
                plans: apiData?.plans?.map((plans: { id: string }) => plans.id),
                serviceAttributes: apiData?.serviceAttributes?.map(
                    (serviceAttributes: { id: string }) => serviceAttributes.id,
                ),
                documitraFees: apiData?.documitraFees ? Number(apiData.documitraFees) : undefined,
                governmentFees: apiData?.governmentFees ? Number(apiData.governmentFees) : undefined,
            };
        }

        case APPLICATION_FORM_PACKAGE_PLANS: {
            return {
                ...apiData,
                features: apiData?.features?.map((feature: { id: string }) => feature.id),
                documents: apiData?.documents?.map((document: { id: string }) => document.id),
                price: apiData?.price ? Number(apiData.price) : undefined,
            };
        }
        case COUPONS_ENTITY: {
            return {
                ...apiData,
                validFrom: apiData.validFrom ? moment(apiData.validFrom, 'YYYY-MM-DD') : '',
                validTo: apiData.validTo ? moment(apiData.validTo, 'YYYY-MM-DD') : '',
            };
        }

        case SERVICE_PROCESS_DETAILS:
        case SERVICE_PROCESS_STEPS: {
            return {
                ...apiData,
                service: apiData?.service?.id,
            };
        }

        case SERVICE_PROCESS_SUBTITLE: {
            return {
                ...apiData,
                title: apiData?.title?.id,
            };
        }

        case GARAGE_COMMISSION_TYPE: {
            return {
                ...apiData,
                commission: apiData?.id,
                garageName: apiData?.garage?.id,
            };
        }

        case USERS_LIST_ENTITY: {
            return {
                ...apiData,
                phone: `+${apiData.countryCode} - ${apiData.phone}`,
            };
        }

        case MANAGER_TECHNICIAN_ENTITY: {
            return {
                manager: apiData?.results?.id,
                technicians: apiData?.results?.technicians?.map((technicians: { id: string }) => technicians.id),
            };
        }

        case CONTACT_INFO: {
            return {
                ...apiData,
                facebook: apiData?.socialMediaLinks?.facebook,
                twitter: apiData?.socialMediaLinks?.twitter,
                email: apiData?.email,
            };
        }

        case ORDER_LIST_ENTITY: {
            return Object.keys(apiData).reduce((acc, key) => {
                if (key === 'store') {
                    return {
                        ...acc,
                        store: apiData[key]?.name,
                        storePhone: apiData[key]?.phone,
                        line1: apiData[key]?.line1,
                        line2: apiData[key]?.line2,
                        state: apiData[key]?.state,
                        city: apiData[key]?.city,
                        latitude: apiData[key]?.latitude,
                        longitude: apiData[key]?.longitude,
                        landmark: apiData[key]?.landmark,
                        storePincode: apiData[key]?.storePincode,
                    };
                }

                if (key === 'address') {
                    return {
                        ...acc,
                        addressType: apiData[key]?.addressType,
                        customerLine1: apiData[key]?.line1,
                        customerLine2: apiData[key]?.line2,
                        streetName: apiData[key]?.streetName,
                        customerLatitude: apiData[key]?.latitude,
                        customerLongitude: apiData[key]?.longitude,
                        customerLandmark: apiData[key]?.landmark,
                        pincode: apiData[key]?.pincode,
                    };
                }
                if (key === 'customer') {
                    return {
                        ...acc,
                        id: apiData[key].id,
                        name: apiData[key].name,
                        email: apiData[key].email,
                        phone: apiData[key].phone,
                        referralCode: apiData[key].referralCode,
                    };
                }

                if (key === 'slots') {
                    const variants = apiData[key]?.reduce((acc: any, slot: any) => [...acc, ...slot.variants], []);

                    const addons = variants?.reduce(
                        (acc: any, variant: any) => [
                            ...acc,
                            ...variant.addons.map((addon: any) => ({
                                ...addon,
                                variantSlug: variant.variantSlug,
                            })),
                        ],
                        [],
                    );

                    const bulkAddons = apiData[key].reduce((acc: any, currentValue: any) => {
                        currentValue.variants.forEach((variant: any) => {
                            if (variant.bulkAddon && Object.keys(variant.bulkAddon).length !== 0) {
                                acc.push(variant.bulkAddon);
                            }
                        });
                        return acc;
                    }, []);

                    return {
                        ...acc,
                        slots: apiData[key],
                        addons,
                        variants,
                        bulkAddons,
                    };
                }

                return { ...acc, [key]: apiData[key] };
            }, {});
        }
    }

    const entityNamesArray = entityName?.split('/');
    const requiredEntityName = entityNamesArray[entityNamesArray.length - 1];

    switch (`/${requiredEntityName}`) {
        default:
            return apiData;
    }
};
